module.exports = __webpack_public_path__ + "media/newstyle/images/icon-googleplay-19beacc41515329b249234db6eab6f49.svg";